/**
 * Loading Spinner Component
 * Migrated to use cambrian-ds Spinner
 */

import { Spinner } from "cambrian-ds";
import { cn } from "@/lib/utils";
import { cambrianColors, typography } from "@/styles/design-tokens";

export function LoadingSpinner() {
  return (
    <div className="flex items-center justify-center h-64">
      <div className="flex flex-col items-center gap-3">
        <Spinner size="lg" />
        <p className={cn(typography.body, cambrianColors.text.secondary)}>
          Loading...
        </p>
      </div>
    </div>
  );
}
